import { Alert } from '../../../models/alert.model';

export class AddAlerts {

  static readonly type = '[ALERT] Add alerts';

  constructor(public payload: Array<Alert>) { }

}
